<template>
  <div class="page-container home-page">
    <div class="home-grid">
      <!-- 左侧主栏 -->
      <div class="home-main">
        <!-- 公益项目 -->
        <section class="page-card home-section">
          <div class="page-card__header">
            <h2 class="section-title section-title--link">
              <span>公益项目</span>
              <RouterLink to="/charityProject" class="section-more">查看更多 →</RouterLink>
            </h2>
          </div>
          <div class="page-card__body">
            <div class="project-grid">
              <a
                v-for="item in charityProjects"
                :key="item.id"
                :href="item.linkUrl"
                target="_blank"
                class="project-card"
              >
                <div class="project-card__img">
                  <img :src="item.mainImgUrl" :alt="item.title" />
                </div>
                <div class="project-card__info">
                  <h3>{{ item.title }}</h3>
                  <span>{{ item.publishDate }}</span>
                </div>
              </a>
            </div>
          </div>
        </section>

        <!-- 机构动态 -->
        <section class="page-card home-section">
          <div class="page-card__header">
            <h2 class="section-title section-title--link">
              <span>机构动态</span>
              <RouterLink to="/organDynamic" class="section-more">查看更多 →</RouterLink>
            </h2>
          </div>
          <div class="page-card__body">
            <a
              v-for="item in organStatus"
              :key="item.id"
              :href="item.linkUrl"
              target="_blank"
              class="news-list-item"
            >
              <div class="news-list-item__thumb">
                <img :src="item.mainImgUrl" :alt="item.title" />
              </div>
              <div class="news-list-item__content">
                <p class="news-list-item__title">{{ item.title }}</p>
                <span class="news-list-item__date">{{ item.publishDate }}</span>
              </div>
            </a>
          </div>
        </section>
      </div>

      <!-- 右侧边栏 -->
      <aside class="home-sidebar">
        <!-- 行业资讯 -->
        <section class="page-card home-section">
          <div class="page-card__header">
            <h2 class="section-title section-title--link">
              <span>行业资讯</span>
              <RouterLink to="/industryInformation" class="section-more">更多 →</RouterLink>
            </h2>
          </div>
          <div class="page-card__body sidebar-news">
            <a
              v-for="item in industryNews"
              :key="item.id"
              :href="item.linkUrl"
              target="_blank"
              class="sidebar-news-item"
            >
              <div class="sidebar-news-item__img">
                <img :src="item.mainImgUrl" :alt="item.title" />
              </div>
              <div class="sidebar-news-item__text">
                <p>{{ item.title }}</p>
                <span>{{ item.publishDate }}</span>
              </div>
            </a>
          </div>
        </section>

        <!-- 信息披露 -->
        <section class="page-card home-section">
          <div class="page-card__header">
            <h2 class="section-title section-title--link">
              <span>信息披露</span>
              <RouterLink to="/informationShow" class="section-more">更多 →</RouterLink>
            </h2>
          </div>
          <div class="page-card__body">
            <ul class="disclosure-list">
              <li v-for="item in informationShow" :key="item.id">
                <a :href="item.linkUrl">{{ item.title }}</a>
              </li>
            </ul>
          </div>
        </section>
      </aside>
    </div>
  </div>
</template>

<script>
import { indexData } from '@/api/cmsApi'

export default {
  name: 'IndexPage',
  data() {
    return {
      charityProjects: [],
      organStatus: [],
      industryNews: [],
      informationShow: []
    }
  },
  created() {
    indexData()
      .then(res => {
        if (res.code === 200) {
          const data = res.data
          this.charityProjects = data.charityProjects || []
          this.organStatus = data.organStatus || []
          this.industryNews = data.industryNews || []
          this.informationShow = data.informationShow || []
        }
      })
      .catch(err => {
        console.warn('[IndexPage]', err.message)
      })
  }
}
</script>

<style scoped>
.home-grid {
  display: grid;
  grid-template-columns: 1fr 340px;
  gap: 24px;
  align-items: start;
}

.home-section {
  margin-bottom: 24px;
}

.home-section:last-child {
  margin-bottom: 0;
}

.project-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.project-card {
  border-radius: var(--radius);
  overflow: hidden;
  border: 1px solid var(--color-border);
  transition: box-shadow var(--transition), transform var(--transition);
}

.project-card:hover {
  box-shadow: var(--shadow-hover);
  transform: translateY(-2px);
}

.project-card__img {
  aspect-ratio: 16 / 10;
  overflow: hidden;
  background: var(--color-border);
}

.project-card__img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform var(--transition);
}

.project-card:hover .project-card__img img {
  transform: scale(1.04);
}

.project-card__info {
  padding: 14px 16px;
  background: #fff;
}

.project-card__info h3 {
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 6px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.project-card__info span {
  font-size: 12px;
  color: var(--color-text-muted);
}

.sidebar-news-item {
  display: flex;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid var(--color-border);
}

.sidebar-news-item:last-child {
  border-bottom: none;
}

.sidebar-news-item__img {
  flex-shrink: 0;
  width: 80px;
  height: 60px;
  border-radius: 6px;
  overflow: hidden;
  background: var(--color-border);
}

.sidebar-news-item__img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sidebar-news-item__text {
  flex: 1;
  min-width: 0;
}

.sidebar-news-item__text p {
  font-size: 13px;
  line-height: 1.5;
  margin: 0 0 6px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.sidebar-news-item:hover .sidebar-news-item__text p {
  color: var(--color-primary);
}

.sidebar-news-item__text span {
  font-size: 12px;
  color: var(--color-text-muted);
}

@media (max-width: 992px) {
  .home-grid {
    grid-template-columns: 1fr;
  }

  .home-sidebar {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
  }
}

@media (max-width: 640px) {
  .project-grid {
    grid-template-columns: 1fr;
  }

  .home-sidebar {
    grid-template-columns: 1fr;
  }
}
</style>
